module.exports = __webpack_public_path__ + "static/img/wangdanwei.a452285.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/livebackground/wangdanwei.jpg
// module id = jMi0
// module chunks = 15